import React from 'react';
import { loader as gqlLoader } from 'graphql.macro';
import GraphQLData from '../../../lib/GraphQLData';
import './masthead.css';
import { isSupportApplication } from '../../../lib/ApplicationTag';
import { buildBreadcrumbItems, getBreadcrumbLabel } from '../../../lib/Breadcrumb';
import { replaceUrlHost } from '../../../lib/Url';
import config from '../../../temp/config';

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
const BreadcrumbQuery = gqlLoader('../breadcrumbQuery.graphql');

const MastheadBreadcrumbs = (props) => {
  const graphQLResult = props.connectedQuery;
  const { sitecoreContext } = props;
  const route = sitecoreContext?.route;

  const isSupport = isSupportApplication(route, sitecoreContext);
  // Async loading and error handling
  // Remember to never return null from a JSS component when loading,
  // this will break Experience Editor.
  const { error, loading } = graphQLResult;

  // Query results load in using the name of their root field (see breadcrumbQuery.graphql)
  const { dsItem } = graphQLResult;

  const navArray = buildBreadcrumbItems(dsItem);

  const getBreadcrumbUrl = (item) => {
    const itemUrl = item.url;

    return isSupport ? replaceUrlHost(itemUrl, config.REACT_APP_SUPPORT_ORIGIN) : itemUrl;
  };

  return (
    <header id="header" className="dev-c-masthead u-layer-4">
      <div data-e2e-id="graphql-connected" className="dev-c-masthead">
        {dsItem !== null && dsItem != undefined && (
          <div>
            {navArray && navArray.length >> 0 && (
              <ads-breadcrumbs
                slot="breadcrumbs"
                sr-label="Breadcrumbs"
                id="ads-breadcrumbs"
                class="hydrated"
              >
                {navArray.slice(1).map((item, index) => (
                  <ads-breadcrumb slot="breadcrumb" link={getBreadcrumbUrl(item)} class="hydrated">
                    {getBreadcrumbLabel(item, index, route?.templateId)}
                  </ads-breadcrumb>
                ))}
              </ads-breadcrumbs>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default GraphQLData(BreadcrumbQuery, { name: 'connectedQuery' })(MastheadBreadcrumbs);
